// extracted by mini-css-extract-plugin
module.exports = {"isi":"ISIFooter_isi__fFQO9","alternative":"ISIFooter_alternative__KNV48"};